"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionUtil = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Utility = {
    GetUserFromStorage: function () {
        var keys = Object.keys(sessionStorage);
        var key = keys.length > 0 ? lodash_1.default.find(keys, function (x) { return x.startsWith('oidc.user'); }) : undefined;
        if (key !== undefined) {
            return sessionStorage.getItem(key);
        }
        else {
            keys = Object.keys(localStorage);
            key = lodash_1.default.find(keys, function (x) { return x.startsWith('oidc.user'); });
            return localStorage.getItem(key);
        }
    },
    GetApplicationResourcePermissions: function (application, user) {
        // If user is not provided then get user user from session storage
        if (user === undefined) {
            var strUser = Utility.GetUserFromStorage();
            if (strUser !== null) {
                user = JSON.parse(strUser);
            }
        }
        if (user === undefined ||
            user.profile === undefined ||
            user.profile.permissions === undefined ||
            user.profile.permissions === '' ||
            user.profile.permissions === '[]') {
            return undefined;
        }
        var permissions = JSON.parse(user.profile.permissions);
        return permissions[application];
    },
    HasPermission: function (resourcePermissions, resource, permission) {
        if (resourcePermissions && resourcePermissions[resource] && new Set(resourcePermissions[resource]).has(permission)) {
            return true;
        }
        return false;
    },
};
/**
 * summary: Permission related utility functions.
 */
exports.PermissionUtil = {
    /**
     * summary: Returns true if user has permission to access a resource.
     * @param application - Application that user is trying to access, ex: UserManagementAPI, QuestionLibraryAPI etc.
     * @param resource - Resource in an application, ex: Question, Hierarchy, Clients, Users etc.
     * @param permission - Permission for resource, ex: View, Edit, Delete etc.
     * @param user - User object containing permissions, for undeclared value user from session is used
     */
    DoesUserHavePermission: function (application, resource, permission, user) {
        var resourcePermissions = Utility.GetApplicationResourcePermissions(application, user);
        return Utility.HasPermission(resourcePermissions, resource, permission);
    },
    /**
     * summary: Returns sidenav items that user has access to.
     * For a menu to be shown user should have access to atleast one sidenav link
     * If resource or permission is not given for a sidenavlink, sidenavlink is shown as default
     * @param application - Application that user is trying to access, ex: UserManagementAPI, QuestionLibraryAPI etc.
     * @param menuItems - Array of sidenav categories.
     * @param user - User object containing permissions, for undeclared value user from session is used
     */
    FilterMenuItemsByPermission: function (application, menuItems, user) {
        if (menuItems === undefined) {
            return [];
        }
        var resourcePermissions = Utility.GetApplicationResourcePermissions(application, user);
        var response = [];
        lodash_1.default.each(menuItems, function (menu) {
            var hasPermissionForMenuItem = true;
            if (menu.resource !== undefined && menu.permission !== undefined) {
                hasPermissionForMenuItem = Utility.HasPermission(resourcePermissions, menu.resource, menu.permission);
            }
            if (menu.menuItems !== undefined) {
                var subMenus_1 = [];
                lodash_1.default.each(menu.menuItems, function (subMenu) {
                    if (subMenu.permission !== undefined && subMenu.resource !== undefined) {
                        if (Utility.HasPermission(resourcePermissions, subMenu.resource, subMenu.permission)) {
                            subMenus_1.push(subMenu);
                        }
                    }
                    else {
                        subMenus_1.push(subMenu);
                    }
                });
                menu.menuItems = subMenus_1;
            }
            if (hasPermissionForMenuItem) {
                response.push(menu);
            }
        });
        return response;
    },
    /**
     * summary: Gets all applications that a user has at least one permission for
     * @param user - User object containing permissions, for undeclared value user from session is used
     */
    GetUserApplications: function (user) {
        // If user is not provided then get user user from session storage
        var response = [];
        if (user === undefined) {
            var strUser = Utility.GetUserFromStorage();
            if (strUser !== null) {
                user = JSON.parse(strUser);
            }
        }
        if (user === undefined ||
            user.profile === undefined ||
            user.profile.apps === undefined ||
            user.profile.apps === '' ||
            user.profile.apps === '[]') {
            return response;
        }
        var applicationApplications = JSON.parse(user.profile.apps);
        if (applicationApplications.length > 0) {
            lodash_1.default.each(applicationApplications, function (appName) {
                response.push(appName);
            });
        }
        return response;
    },
};
